let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Ypfg")).then(() => parcelRequire('dicM4'));